<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat industrial design",
    "pageDesc":"We provide industrial design that includes concept innovation, 3D renders, design strategy, ergonomics, and tooling among others.",
    "mantra":"Functional industrial |designs.",
    "sec1Items":{
      "1":{
        "title":"New product development",
        "desc":"From ideas to full production execution and launch, we work closely on innovative concepts and do the necessary research to develop a product that closes a market gap."
      },
      "2":{
        "title":"Product upgrades",
        "desc":"Collaborating with you to launch the second version of the product and optimize for a better user experience and performance."
      },
      "3":{
        "title":"Product redesign",
        "desc":"Rethinking your current look and functionality then conducting researches to select the new materials, textures, specifications and outline the production process."
      }
    },
    "sec2":"Design process that is tailored around end users.",
    "sec2Items":{
      "1":{
        "title":"Design research",
        "desc":"By understanding the project specifications and the needs it's trying to fulfill, we set targets and agree on the international standards that must be met."
      },
      "2":{
        "title":"Brand development",
        "desc":"From the current product design or concept doodles, we develop a brand that matches future product portfolio expansion and engages the end users."
      },
      "3":{
        "title":"Design strategy",
        "desc":"Studying the different approaches of production and considering the manufacturing and tooling process to set the release dates."
      },
      "4":{
        "title":"Competitor research",
        "desc":"Examining the market leaders to inspire how they overcame the product development issues and met the conceptual model of the users."
      },
      "5":{
        "title":"Customer research",
        "desc":"Discovering the gaps and demands of the end customer through empathy mapping, behavior analysis and other qualitative and quantitative methods."
      },
      "6":{
        "title":"Concept innovation",
        "desc":"Brainstorming and thinking critically about the product to come up with a concept that can be patented. Sketching ideas and studying ergonomics to understand where customers experience frustrations."
      },
      "7":{
        "title":"Product design",
        "desc":"Constructing models of the product and coming up with a functioning prototype whether in 3D animation, rendering or tangible versions that includes the software as well."
      },
      "8":{
        "title":"Product optimization",
        "desc":"Based on the tests conducted, we optimize the product manufacturing process, production costs and material selection."
      },
      "9":{
        "title":"Product promotion",
        "desc":"From the package design, to website creation and product presentations, we create all the necessary advertising elements to help you communicate with your target audience."
      }
    },


    "cta":"Implement your <br> visionary  concept."
  },
  "ar": {
    "pageTitle":"التصميم الصناعي",
    "pageDesc":"نقدم التصميم الصناعي بطريقة تشمل مفهوم الابتكار واستراتيجية التصميم والعروض ثلاثية الأبعاد من أجل تقديم نموذج مثالي لك.",
    "mantra":"نبتكر التصميم الصناعي |لوظائف أكثر فاعلية.",
    "sec1Items":{
      "1":{
        "title":"تطوير منتج جديد",
        "desc":"من الفكرة إلى التنفيذ وحتى التنفيذ والإطلاق للمنتج، نعمل عن كثب على المفاهيم المبتكرة ونجري البحوث اللازمة من أجل تطوير منتج يسد احتياجات المستخدم والسوق."
      },
      "2":{
        "title":"تحديثات المنتج",
        "desc":"نتعاون معك من أجل إطلاق الإصدار الثاني من المنتج من أجل تحسين تجربة المستخدم والأداء بما يتناسب مع المستخدمين."
      },
      "3":{
        "title":"إعادة تصميم المنتج",
        "desc":"نعمل على إعادة التفكير في مظهرك الحالي والوظائف الخاص بك، ثم نجرى الأبحاث  لتحديد المواد والمواصفات الجديدة وتحديد عملية الإنتاج."
      }
    },
    "sec2":"عملية تصميم أساسها المستخدم النهائي.",
    "sec2Items":{
      "1":{
        "title":"مرحلة الأبحاث",
        "desc":"من خلال فهم مواصفات المشروع والاحتياجات التي تحاول الوفاء بها، نحدد الأهداف والمعايير الدولية التي يجب علينا تنفيذها."
      },
      "2":{
        "title":"تطوير العلامة التجارية",
        "desc":"بداية من التصميم الحالي للمنتج أو الخربشات التي قمنا بها، نقوم بتطوير علامة تجارية تتوافق مع التوسع الذي يمكنك القيام به مع المنتجات المستقبلية وتتناسب مع المستخدمين النهائيين."
      },
      "3":{
        "title":"استراتيجية التصميم",
        "desc":"نقوم بدراسة الطرق المختلفة للإنتاج وننظر في عمليات التصنيع المختلفة والأدوات المستخدمة من أجل تحديد تواريخ الإصدار."
      },
      "4":{
        "title":"دراسة المنافسين",
        "desc":"نقوم بدراسة رواد السوق من أجل معرفة كيف تغلبوا على مشكلات تطوير المنتج، وكيف قاموا بالمواءمة للتواصل إلى النموذج المناسب للمستخدمين."
      },
      "5":{
        "title":"دراسة المستخدمين",
        "desc":"نعمل على اكتشاف الفجوات ومطالب المستخدمين النهائية من خلال خرائط التعاطف وتحليل السلوك وغيرها من الأساليب الكمية والكيفية."
      },
      "6":{
        "title":"مفهوم الابتكار",
        "desc":"نعتمد على العصف الذهني والتفكير النقدي للتوصل إلى مفهوم مميز يمكن الحصول من خلال على براءة اختراع. نقوم برسم الأفكار ودراسة بيئة العمل لفهم أين يمكن أن يحدث مشكلة مع للمستخدمين."
      },
      "7":{
        "title":"تصميم المنتج",
        "desc":"نعمل على بناء نماذج للمنتج والخروج بنموذج أولي فعال سواء من خلال رسوم متحركة ثلاثية الأبعاد أو الريندرينج أو الإصدارات الملموسة التي تشمل البرنامج كذلك."
      },
      "8":{
        "title":"تحسين المنتج",
        "desc":"بناءً على الاختبارات التي قمنا بها، نقوم بتحسين عملية تصنيع المنتج وتكاليف الإنتاج واختيار المواد المناسبة من أجل المستخدمين النهائيين."
      },
      "9":{
        "title":"الترويج للمنتج",
        "desc":"من تصميم الأغلفة إلى إنشاء الموقع وعروض المنتجات، نساعدك على إنشاء جميع العروض اللازمة لمساعدتك من أجل التواصل مع جمهورك المستهدف."
      }
    },


    "cta":"حول أفكارك إلى <br> منتجات فعالة. "
  }
}
</i18n>
